import {defineAsyncComponent} from 'vue'
const RelativesDirectorRouter = [
  {
    path: 'director_core',
    name: 'directorCore',
    redirect: 'OrganizeDirectorSet',
    meta: {
      key: 'relatives-director'
    },
    children: [
      {
        path: 'director_set',
        name: 'OrganizeDirectorSet',
        component: () => import('@/views/Relatives/DirectorSet.vue'),
        meta: {
          key: 'relatives-director'
        }
      },
      {
        path: 'director',
        name: 'OrganizeDirector',
        component: () => import('@/views/Relatives/Director.vue'),
        meta: {
          key: 'relatives-director'
        }
      },
      {
        path: 'stats',
        name: 'OrganizeStats',
        component: () => import('@/views/Relatives/Stats.vue'),
        meta: {
          key: 'relatives-director'
        }
      },
      {
        path: 'blogger',
        name: 'OrganizeBlogger',
        component: () => import('@/views/Relatives/Blogger.vue'),
        meta: {
          key: 'relatives-director'
        }
      },
    ]
  },
  
]
export {RelativesDirectorRouter}
